export default __webpack_public_path__ + "62b0a4891b8466ab79693b765e9d234a.png";